import { suppliesInventoryConfigIdFormat } from "@redotech/redo-marketplace-id";
import * as z from "zod";

export const setSuppliesInventoryLevel = {
  name: "setSuppliesInventoryLevel" as const,
  input: z.object({
    configId: suppliesInventoryConfigIdFormat.schema,
    /** New absolute on-hand count in units; server records the delta. */
    targetUnits: z.number().int().min(0),
    note: z.string().nullish(),
  }),
  output: z.object({ availableInventory: z.number().int() }),
};
